// import "./utils/wdyr";
import "core-js/stable";
import "regenerator-runtime/runtime";
import { createRoot } from 'react-dom/client';
import { AppContainer } from "./containers/app/app-container"
import { Provider } from "react-redux";
import { store } from "./redux/store";
import { Suspense } from "react";
import { BrowserRouter } from "react-router-dom";
import { LoadingSpinner } from "./containers/common/loading-spinner/loading-spinner";
import 'bootstrap/dist/css/bootstrap.min.css';
import "react-datepicker/dist/react-datepicker.css";
import 'react-international-phone/style.css';

const root = createRoot(document.getElementById('root'));

root.render(
    <Provider store={store}>
        <Suspense fallback={<LoadingSpinner loadingText="Loading..." />}>
            <BrowserRouter>
                <AppContainer />
            </BrowserRouter>
        </Suspense>
    </Provider>
);

if (process.env.NODE_ENV !== "production" && module.hot) {
    module.hot.accept(() => {
        root.render(
            <Provider store={store}>
                <Suspense fallback={<LoadingSpinner loadingText="Loading..." />}>
                    <BrowserRouter>
                        <AppContainer />
                    </BrowserRouter>
                </Suspense>
            </Provider>
        );
    })
}